import React from "react";
import { useTranslation } from "react-i18next";
import Common from "us.common";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "us.helper/types";

const { $Divider, $AmountLabel } = Common.Components;

/**
 * @description - FileConverter component summery for preview uploaded file.
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @link Task - https://unicorn-solutions.atlassian.net/browse/UBX4-25356
 * @since 17/06/2025
 */
const Summary: React.FC<PropsFromRedux> = (props) => {
  const { t } = useTranslation();

  const { previewResult, fileList } = props;

  const { HeaderInfo, CaseList } = previewResult ?? {};
  const { FileCreator, FileType, Checksums } = HeaderInfo ?? {};
  const { TotalMainAmount } = Checksums ?? {};

  return (
    <>
      <div className="px-3 pb-2">
        <div data-testid="preview-summary">
          <div className="d-flex flex-column">
            <h2 className="mb-4">
              {t("US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FILE_SUMMARY")}
            </h2>
            <div className="mt-2">
              <div className="d-flex justify-content-between">
                <span>
                  {t("US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FILE_NAME")}
                </span>
                <span
                  data-testid="upload-file-name"
                  className="font-weight-bold text-right"
                >
                  {fileList.length > 0 ? fileList[0].name : ""}
                </span>
              </div>
            </div>
            <$Divider />
            <div>
              <div className="d-flex justify-content-between">
                <span>
                  {t("US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.UPLOADED_BY")}
                </span>
                <span
                  data-testid="fileCreator"
                  className="font-weight-bold text-right"
                >
                  {FileCreator || "-"}
                </span>
              </div>
            </div>
            <$Divider />
            <div className="d-flex justify-content-between">
              <span>
                {t("US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.FILE_TYPE")}
              </span>
              <span
                data-testid="fileType"
                className="font-weight-bold text-right"
              >
                {FileType || "-"}
              </span>
            </div>
            <$Divider />
            <div className="d-flex justify-content-between">
              <span>
                {t("US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.CASE_COUNT")}
              </span>
              <span
                data-testid="caseListCount"
                className="font-weight-bold text-right"
              >
                {CaseList?.length || 0}
              </span>
            </div>
            <$Divider />
            <div className="d-flex justify-content-between">
              <span>
                {t(
                  "US.COLLECTION.INPUT-OUTPUT:FILE_CONVERTER.TOTAL_MAIN_AMOUNT"
                )}
              </span>
              <span
                data-testid="totalMainAmount"
                className="font-weight-bold text-right"
              >
                <$AmountLabel value={TotalMainAmount} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const { fileConverter } = state;

  const { preview, fileList } = fileConverter;

  return {
    fileList,
    previewResult: preview.data,
  };
};

const connector = connect(mapStateToProps, {});

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Summary);